<template>
    <el-row type="flex" class="menu complex">
        <!--todo 選中狀態樣式加上 active-->
        <div v-for="(item, index) in list" :key="index" class="item" @click="itemClick(item)">
            <img :src="item.img">
            <span>{{item.name}}</span>
        </div>
    </el-row>
</template>

<script>
    import * as constDefine from '@/store/constDefine'

export default {
    name: "QuickMenuComplex",
    props: {

    },
    data() {
        return {
            list:[
                {
                    img:require('@/assets/images/quickMenu/coupon.svg'),
                    name:'搶券熱區',
                    id: constDefine.TAB_ID_COUPON,
                },
                {
                    img:require('@/assets/images/quickMenu/takeout.svg'),
                    name:'外帶外送',
                    id: constDefine.TAB_ID_TAKEOUT,
                },
                {
                    img:require('@/assets/images/quickMenu/booking.svg'),
                    name:'線上訂位',
                    id: constDefine.TAB_ID_BOOKING,
                },
                {
                    img:require('@/assets/images/quickMenu/market.svg'),
                    name:'商圈夜市',
                    id: constDefine.TAB_ID_MARKET,
                },
                {
                    img:require('@/assets/images/quickMenu/activity.svg'),
                    name:'主題活動',
                    id: constDefine.TAB_ID_ACTIVITY,
                },
            ]
        }
    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {
        /** 按鈕後跳頁 */
        itemClick: function(item) {
            this.$router.push({name: 'Complex', query:{showType: item.id}});
        },
    }
}
</script>
